import request from '@/utils/request';

/**
 * 商户管理相关接口
 */

// 阶梯式配送费规则
export interface DeliveryFeeRule {
  minAmount: number; // 订单金额下限（包含）
  maxAmount: number | null; // 订单金额上限（不包含），null 表示无上限
  fee: number; // 配送费
}

// 商户信息接口返回类型
export interface MerchantInfo {
  id?: number | string; // 商户 ID
  name: string; // 店铺名称
  logo: string; // 店铺 Logo
  phone: string; // 联系电话
  businessHours: string; // 营业时间，格式如 "10:00-22:00"
  address: string; // 店铺地址
  minOrderAmount: number; // 起送金额
  deliveryFeeRules: DeliveryFeeRule[]; // 阶梯式配送费规则
  deliveryRange?: number; // 配送范围(km)
  deliveryTime?: number; // 预计送达时间(分钟)
}

// 获取商户信息
export const getMerchantInfo = () => {
  return request({
    url: '/shop/getMerchantInfo',
    method: 'get'
  });
};

// 设置商户信息
export const setMerchantInfo = (data: Partial<MerchantInfo>) => {
  return request({
    url: '/shop/setMerchantInfo',
    method: 'put',
    data
  });
};
